/* Foamera — MOBILE-ONLY steps-first PDP (2026-07-15 draft)

   Desktop is deliberately left EXACTLY as the theme built it:
     right column = title / trust / price / prose (bullets + tabs) / payment
     configurator = full-width block below.

   Mobile only (≤1023px): everything stacks, and the prose + payment row sat
   between the price and the steps — pushing the configurator ~600px down.
   So on mobile we move ONLY the prose block and the payment row to the end of
   the step container, under Review & Confirm. The steps then land right under
   the price. The step container itself is never moved.

   Reversible: original positions are captured before the first move and restored
   if the viewport crosses back to desktop.
   Step logic, step order and all imagery are untouched. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 1023px)');
  var saved = null;

  function snap(el) {
    return el && el.parentNode ? { el: el, parent: el.parentNode, next: el.nextSibling } : null;
  }
  function put(s) {
    if (s && s.parent) s.parent.insertBefore(s.el, s.next);
  }

  function apply() {
    var grid = document.querySelector('.pcfg-below-grid');
    if (!grid) return;

    var review = grid.querySelector('[data-pcfg-review-section]');
    var anchor = review || grid.lastElementChild;
    if (!anchor) return;

    var slot = document.querySelector('[data-pcfg-info-slot]');
    var pay = document.querySelector('.pcfg__payment-row');
    if (!slot && !pay) return;

    if (!saved) saved = {};
    /* capture home position BEFORE the first move so desktop can be restored */
    if (slot && !saved.slot && !slot.classList.contains('fmr-info-below')) saved.slot = snap(slot);
    if (pay && !saved.pay && !pay.classList.contains('fmr-pay-below')) saved.pay = snap(pay);

    if (slot) {
      slot.classList.add('fmr-info-below');
      grid.insertBefore(slot, anchor.nextSibling);
      anchor = slot;
    }
    if (pay) {
      pay.classList.add('fmr-pay-below');
      grid.insertBefore(pay, anchor.nextSibling);
    }
  }

  function undo() {
    if (!saved) return;
    if (saved.slot) { saved.slot.el.classList.remove('fmr-info-below'); put(saved.slot); }
    if (saved.pay) { saved.pay.el.classList.remove('fmr-pay-below'); put(saved.pay); }
  }

  function sync() {
    if (MQ.matches) apply();
    else undo();
  }

  function boot() {
    if (!document.getElementById('pcfg-root')) return;
    sync();
    /* the theme builds .pcfg-below-grid and cfg-core.js fills the info slot async */
    var t = 0;
    var iv = setInterval(function () {
      sync();
      if (++t > 24) clearInterval(iv);
    }, 250);
    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    else if (MQ.addListener) MQ.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
